import {Component, Input, OnInit} from '@angular/core';
import {TablePulseAbstractComponent} from '../../table-pulse-abstract/table-pulse-abstract.component';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-table-pulse-text',
  templateUrl: './table-pulse-text.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TablePulseTextComponent extends TablePulseAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

  ngOnInit(): void {
  }

}
